// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__wa8Y1","savePackageButton":"ClientWallet_savePackageButton__4cYgr"};